// product bundle 
// document.addEventListener("DOMContentLoaded", function () {
//   $(".custom_gift_bundling").on("change", function () {
//     let selectedValues = [];

//     $(".custom_gift_bundling:checked").each(function () {
//       selectedValues.push($(this).val());
//     });

//     let html = "";
//     selectedValues.forEach(function (variantId, index) {
//       html += `<input type="hidden" name="items[${index + 1}][id]" value="${variantId}">`;
//     });

//     $(".custom_free_bundling_wrapper").html(html);
//   });
// });

// document.addEventListener("DOMContentLoaded", function () {
//   // ===== 新增：截止时间判断 =====
//   const endDate = new Date("2026-04-20T23:59:59");
//   const now = new Date();

//   // 到时间后隐藏并停止执行
//   if (now >= endDate) {
//     $(".product-upsell-bundle-box").hide(); // 改成你要隐藏的区域
//     return;
//   }

//   // 1. 定义一个统一的更新函数
//   function updateBundlingInputs() {
//     let selectedValues = [];

//     // 获取所有被选中的复选框的值
//     $(".custom_gift_bundling:checked").each(function () {
//       selectedValues.push($(this).val());
//     });

//     let html = "";
//     selectedValues.forEach(function (variantId, index) {
//       html += `<input type="hidden" name="items[${index + 1}][id]" value="${variantId}">`;
//     });

//     // 将生成的隐藏 input 放入容器
//     $(".custom_free_bundling_wrapper").html(html);
//   }

//   // 2. 页面加载完成后立即执行一次
//   updateBundlingInputs();

//   // 3. 当用户手动切换勾选状态时执行
//   $(".custom_gift_bundling").on("change", function () {
//     updateBundlingInputs();
//   });
// });

document.addEventListener("DOMContentLoaded", function () {

  // 1. 定义一个统一的更新函数
  function updateBundlingInputs() {
    let selectedValues = [];

    // 获取所有被选中的复选框的值
    $(".custom_gift_bundling:checked").each(function () {
      selectedValues.push($(this).val());
    });

    let html = "";
    selectedValues.forEach(function (variantId, index) {
      html += `<input type="hidden" name="items[${index + 1}][id]" value="${variantId}">`;
    });

    // 将生成的隐藏 input 放入容器
    $(".custom_free_bundling_wrapper").html(html);
  }

  // 2. 页面加载完成后立即执行一次
  updateBundlingInputs();

  // 3. 当用户手动切换勾选状态时执行
  $(".custom_gift_bundling").on("change", function () {
    updateBundlingInputs();
  });

});

// document.addEventListener("DOMContentLoaded", function () {
//   // 1. 定义一个统一的更新函数
//   function updateBundlingInputs() {
//     let selectedValues = [];

//     // 获取所有被选中的复选框的值
//     $(".custom_gift_bundling:checked").each(function () {
//       selectedValues.push($(this).val());
//     });

//     let html = "";
//     selectedValues.forEach(function (variantId, index) {
//       // 这里的 index + 1 确保了 items[1], items[2] 这种格式
//       html += `<input type="hidden" name="items[${index + 1}][id]" value="${variantId}">`;
//     });

//     // 将生成的隐藏 input 放入容器
//     $(".custom_free_bundling_wrapper").html(html);
//   }

//   // 2. 页面加载完成后立即执行一次（处理默认选中的情况）
//   updateBundlingInputs();

//   // 3. 当用户手动切换勾选状态时执行
//   $(".custom_gift_bundling").on("change", function () {
//     updateBundlingInputs();
//   });
// });
// function toggleShowed() {
//   var bundlesText = document.querySelector(".product-discount-shower-bundling");
//   var bundlesbtnstext = document.querySelector(".product-bundles-btns-text");
//   var BundlesDown = document.querySelector(".BundlesDown-icon");

//   if (bundlesText.classList.contains("expanded")) {
//     bundlesText.classList.remove("expanded");
//     bundlesbtnstext.textContent = "Show more";
//     BundlesDown.classList.remove("up");
//   } else {
//     bundlesText.classList.add("expanded");
//     bundlesbtnstext.textContent = "Show less";
//     BundlesDown.classList.add("up");
//   }
// }



// document.addEventListener("DOMContentLoaded", function () {

//   document.querySelectorAll(".products-expand-bundling").forEach(container => {

//     const wrapper = container.closest(".product-bundles-list-container");
//     if (!wrapper) return;

//     const footer = wrapper.querySelector(".bundles-footer");
//     if (!footer) return;

//     const button = footer.querySelector(".product-bundles-bespeak-item");
//     const selectedCountEl = footer.querySelector(".selected-count");

//     const items = container.querySelectorAll(".product-bundles__item");
//     const checkboxes = container.querySelectorAll(".custom_gift_bundling");

//     if (!button || !items.length) return;

//     let collapsedHeight = 0;
//     let isExpanded = false;

//     // ✅ 记录每个 item 初始 hidden 状态
//     const initialHiddenStates = Array.from(items).map(item => item.hasAttribute("hidden"));

//     function calculateCollapsedHeight() {
//       collapsedHeight = container.offsetHeight;
//       if (!isExpanded) container.style.maxHeight = collapsedHeight + "px";
//     }

//     calculateCollapsedHeight();
//     container.style.overflow = "hidden";

//     // ✅ 计算当前 hidden 数量
//     function getHiddenCount() {
//       return Array.from(items).filter(item => item.hasAttribute("hidden")).length;
//     }

//     // 初始化按钮文字
//     button.textContent = `Show (${getHiddenCount()}) more`;

//     button.addEventListener("click", function () {
//       if (!isExpanded) {
//         // 展开
//         items.forEach(item => item.removeAttribute("hidden"));
//         container.style.maxHeight = container.scrollHeight + "px";
//         button.textContent = "Show less";
//       } else {
//         // 收起 → 恢复原始 hidden 状态
//         items.forEach((item, index) => {
//           if (initialHiddenStates[index]) {
//             item.setAttribute("hidden", "");
//           } else {
//             item.removeAttribute("hidden");
//           }
//         });
//         container.style.maxHeight = collapsedHeight + "px";
//         button.textContent = `Show (${getHiddenCount()}) more`;
//       }
//       isExpanded = !isExpanded;
//     });

//     window.addEventListener("resize", calculateCollapsedHeight);

//     function updateSelectedCount() {
//       const selected = Array.from(checkboxes).filter(cb => cb.checked).length;
//       selectedCountEl.textContent = selected > 0 ? `${selected} Selected` : "";
//     }

//     checkboxes.forEach(cb => cb.addEventListener("change", updateSelectedCount));
//   });

// });
